import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'

import OAuthCallback from '../containers/OAuthCallback'
import Events from '../pages/Events'
import EventDetails from '../pages/EventDetails'
import Customers from '../pages/Customers'
import CustomerDetails from '../pages/CustomerDetails'
import Staff from '../pages/Staff'
import StaffDetails from '../pages/StaffDetails'
import SuiteDetails from '../pages/SuiteDetails'
import SuiteEditPage from '../pages/SuiteEdit'
import SuiteMenusPage from '../pages/SuiteMenus'

import { redirectToLogin, refreshToken, isOutsideIframe, isAuth } from '../utils/auth'
import AuthorizedRoute from './AuthorizedRouter'

export default class Routes extends Component {
  tokenRefreshIntervalId = null

  componentDidMount() {
    if (isOutsideIframe()) {
      if (isAuth()) {
        this.setTokenRefreshInterval(refreshToken)
      } else {
        redirectToLogin()
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.tokenRefreshIntervalId)
  }

  setTokenRefreshInterval = callback => {
    callback()
    this.tokenRefreshIntervalId = setInterval(() => callback(), 60000)
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route component={OAuthCallback} exact path="/oauth/callback" />
          <Route component={() => redirectToLogin()} exact path="/login" />
          <AuthorizedRoute component={Events} exact path="/events" />
          <AuthorizedRoute component={EventDetails} exact path="/events/:eventId" />
          <AuthorizedRoute component={SuiteDetails} exact path="/events/:eventId/:standId/:customerId" />
          <AuthorizedRoute component={SuiteEditPage} exact path="/suites/edit/:eventId/:customerOrAttendant" />
          <AuthorizedRoute component={SuiteMenusPage} exact path="/suites/menus/:eventId/:employeeId" />
          <AuthorizedRoute component={Customers} exact path="/customers" />
          <AuthorizedRoute component={CustomerDetails} exact path="/customers/:id" />
          <AuthorizedRoute component={Staff} exact path="/staff" />
          <AuthorizedRoute component={StaffDetails} exact path="/staff/:staffId" />
          <Redirect from="/" to="/events" />
        </Switch>
      </Router>
    )
  }
}
